/**
 * Punto de entrada para habilitar el sistema de mocking con MSW
 * Esta función se ejecuta antes de montar la aplicación Vue
 */

/**
 * Habilita el mocking de requests HTTP con MSW
 * Solo se activa en modo desarrollo y cuando VITE_USE_MOCK_DATA está en true
 * 
 * @returns Promise que se resuelve cuando el Service Worker está listo
 */
export async function enableMocking() {
  // Solo habilitar en modo desarrollo
  if (import.meta.env.MODE !== 'development') {
    return
  }

  // Verificar si el modo mock está habilitado
  if (import.meta.env.VITE_USE_MOCK_DATA !== 'true') {
    console.log(
      '%c⚠️ Modo Mock Deshabilitado',
      'color: #f59e0b; font-weight: bold; font-size: 14px;',
    )
    console.log(
      '%cPara habilitar, cambia VITE_USE_MOCK_DATA=true en .env',
      'color: #f59e0b;',
    )
    return
  }

  // Importar dinámicamente el worker (code splitting)
  const { worker } = await import('./browser')

  // Iniciar el Service Worker
  await worker.start({
    // No mostrar warnings por requests no mockeadas
    // Esto permite que requests reales coexistan con mocks
    onUnhandledRequest: 'bypass',

    // Configuración del Service Worker
    serviceWorker: {
      url: '/mockServiceWorker.js',
    },

    // Opciones adicionales
    quiet: false, // Mostrar mensajes de inicio en consola
  })

  // Mensaje de confirmación visual
  console.log(
    '%c🎭 MSW Activado',
    'color: #ff6a33; font-weight: bold; font-size: 16px; padding: 4px 8px; background: #fff; border: 2px solid #ff6a33; border-radius: 4px;',
  )
  console.log(
    '%c✨ Mock Service Worker está interceptando requests HTTP',
    'color: #ff6a33; font-size: 14px;',
  )
  console.log(
    '%c📝 Todas las requests HTTP serán interceptadas y mockeadas',
    'color: #10b981;',
  )
  console.log(
    '%c⚙️  Para desactivar: VITE_USE_MOCK_DATA=false en .env',
    'color: #6b7280;',
  )
}
